import HeaderComponent from './Header.vue'
export default HeaderComponent
